// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class ServiceAssetNestedResource extends Resource {
    basePath: string = 'services/services/{parent}/service-asset/';

    objectPath: string = 'services/services/{parent}/service-asset/{ident}/';
}
